// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"e152608f","513":"b0e422ac","703":"9075e414","787":"72292f66"}[chunkId] + ".chunk.js";
};